import type { ISection } from '../model';

export const useSectionApi = () => {
  const { $jsonApi } = useNuxtApp();

  const fetchAll = async () => {
    return (
      await $jsonApi
        .prefix('api')
        .all('section')
        .get<ISection[]>({
          filters: {
            with_disabled: false,
          },
          include: 'custom_page',
        })
    ).data;
  };

  return { fetchAll };
};
